export enum TypeAdresseEnum {
    POSTALE = 1,
    FACTURATION = 2
}
